<script>
    import MobileNavbar from '../reusableitems/mobileNavbar.svelte';
    import Mobilebtn2 from './mobilebtn2.svelte';
</script>
<div class="navbar">
    <MobileNavbar />
</div>
<main>
    <div class="main-div">
        <div class=base>
            <p>
                The world is changing at a rapid pace and we’re at the forefront of
                where it is headed.
            </p>
            <p id="paragraph2">
                With a global decentralized community of young artists, creators,
                dreamers and visionary, we’re changing the meaning of what it means
                to create, to advertise and to experience
            </p>
            <p id="paragraph3">
                We started with the vision of a technology that will change the
                world, with the knowledge that <span class=minor>if `content is king`, then 3D content is `the king of kings`.</span
                >
            </p>
            <p id="paragraph4">
                Now we’re jumping straight into capitalizing it through the global
                and universal appeal by building a community. We’re looking for the
                early believers who understand the difference between making a quick
                buck and owning an entire industry.
            </p>
        </div>
        <div style="width:fit-content;margin:auto;margin-top:32.477vw;">
            <!-- <button class="button"> Join Investment Governace Council </button> -->
            <Mobilebtn2
            bgcolor = "#ffcc33"
            width = "60.748vw"
            height = "10.047vw"
            border = "#ffcc33"
            state = "Investor"
            />
        </div>
        <div class="image">
            <img
                src="images/coinimage.png"
                alt="coinimage"
                width="100%"
                height="100%"
            />
        </div>
    </div>
    
</main>

<style>
    .main-div{
        position: absolute;
        width: 100vw;
        height: 100%;
    }
        .navbar{
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 4;
    }
    .base {
        margin-left: 7.009vw;
        font-family: 'Orbitron';
        color: #000000;
        font-style: normal;
        text-align: left;
        letter-spacing: 6%;
        position: relative;
    }
    .base p:nth-child(1) {
        max-width: 79.617vw;
        font-weight: 700;
        font-size: 4.673vw;
        margin-top: 39.486vw;
        line-height: 5.35vw;
        letter-spacing: 0.06em;
    }
    .base p:nth-child(2) {
        margin-top: 7.009vw;
        max-width: 73.364vw;
        font-weight: 700;
        font-size: 2.57vw;
        line-height: 3.598vw;
        letter-spacing: 0.06em;
    }
    .base p:nth-child(3) {
        margin-top: 7.477vw;
        max-width: 67.262vw;
        font-weight: 400;
        font-size: 2.57vw;
        line-height: 3.598vw;
        letter-spacing: 0.06em;
    }
    .base p:nth-child(4) {
        margin-top: 10.682vw;
        max-width: 46.028vw;
        font-weight: 400;
        font-size: 2.57vw;
        line-height: 3.598vw;
        letter-spacing: 0.06em;
    }
    /* .button {
        margin-top: 31.477vw;
        height: 9.346vw;
        width: 65.421vw;
        font-family: 'Orbitron';
        font-weight: 800;
        font-size: 2.804vw;
        line-height: 3.505vw;
        background-color: #ffcc33;
        position: relative;
        border: none;
    } */
    .image {
        position: absolute;
        top: 89vw;
        width: 100vw;
        z-index: -1;
    }
    .minor {
        margin-top: 7.009vw; 
        max-width: 73.364vw; 
        font-weight: 700; 
        font-size: 2.570vw;
        line-height: 3.598vw;
    }
    main {
        text-align: center;
        width: 100vw;
        height: 100%;
        position: relative;
    }
</style>
